import { Text } from "@/components/ui/Text";
import { Title } from "@/components/ui/Title";
import { Divider, Space, Stack } from "@mantine/core";
import { config } from "@/config";
import { useIsPartnerApp } from "@/store/selectors/featureSelectors";
import { Link } from "@/components/ui/Link";

export const SupportPage = () => {
  const isPartnerApp = useIsPartnerApp();

  return (
    <Stack
      align="center"
      justify="center"
      pt={120}
      gap="xs"
      w="100%"
      maw={800}
      mx="auto"
    >
      <Title>Contact support</Title>
      <Text maw={600} ta="center">
        If you need help, have a question, or want to report an issue, please
        email us at{" "}
        <a
          href={`${config.supportMailtoLink}`}
          style={{ textDecoration: "underline" }}
        >
          {config.supportEmail}
        </a>{" "}
        and we'll get back to you as soon as possible.
      </Text>
      <Space h="xs" />
      {isPartnerApp && (
        <>
          <Divider w="100%" />
          <Text ta="center" maw={600}>
            If you need help with assignments, you may want to check out our{" "}
            <Link
              to="https://docs.google.com/document/d/1fM0jLrgVXltkgwajnULBelx-wPRnFuubFvnuXNubuS0/edit?usp=sharing"
              target="_blank"
            >
              Assignment Guide + FAQ
            </Link>{" "}
            which has all sorts of breakdowns, how-to's, videos, and more.
          </Text>
        </>
      )}
    </Stack>
  );
};
